import axios from '@/lib/axios'
import { useMutation } from '@tanstack/vue-query'
import { ref } from 'vue'

interface Params {
	otp: string
	email: string
}

// El correo viaja en el body, nunca en la URL: `otp/user/{correo}` lo dejaba en
// los logs de acceso y de peticiones de BookingV2.
const sendOtp = async (params: Omit<Params, 'otp'>) => {
	const { status } = await axios.post('otp/send', { email: params.email })
	return { status }
}

const postOptUser = async (params: Params) => {
	const { data, status } = await axios.post('otp/login', {
		email: params.email,
		otp: params.otp,
	})
	return { data, status }
}

const useOtpUser = (params: Omit<Params, 'otp'>) => {
	const email = ref(params.email)

	// Mutación y no query: pedir el código manda un correo, así que no se
	// reintenta solo, y un error (correo inválido, demasiados intentos) llega a
	// quien llamó en vez de pasar como éxito.
	const sendOtpMutation = useMutation({
		mutationFn: () => sendOtp({ email: email.value }),
	})

	const postOptUserMutation = useMutation({
		mutationFn: (params: Params) => postOptUser(params),
	})

	return {
		data: sendOtpMutation.data,
		isLoading: sendOtpMutation.isLoading,
		error: sendOtpMutation.error,
		refetch: () => sendOtpMutation.mutateAsync(),
		email,

		postOptUserMutation: postOptUserMutation,
		postOptUserMutationAsync: postOptUserMutation.mutateAsync,
		postOptUserMutationError: postOptUserMutation.error,
		postOptUserMutationIsLoading: postOptUserMutation.isLoading,
	}
}

export default useOtpUser
